import Chip from '@components/chip'
import { SanityProductGender } from '@data/sanity/queries/types/product'
import { StringsContext } from '@lib/strings-context'
import { useContext, useMemo } from 'react'

interface ProductHeroChipsProps {
  gender?: SanityProductGender
  inStock: boolean
  lowStock: boolean
  productPrice: number
  productComparePrice?: number
  isPreorderActive?: boolean
  isAvailabilityCountdownActive?: boolean
}

const ProductHeroChips = ({
  gender,
  inStock,
  lowStock,
  productPrice,
  productComparePrice,
  isPreorderActive,
  isAvailabilityCountdownActive,
}: ProductHeroChipsProps) => {
  const strings = useContext(StringsContext)

  const productDiscountText = useMemo(() => {
    if (!productComparePrice) {
      return
    }

    const discount = (productComparePrice - productPrice) / productComparePrice
    const discountPercent = Math.ceil(discount * 100)

    return strings.productDiscountText?.replace(
      /{percent}/gi,
      discountPercent.toString(),
    )
  }, [productComparePrice, productPrice, strings])

  return (
    <>
      {isPreorderActive && (
        <Chip label={strings.productPreorderLabel} color="yellow" />
      )}
      {isAvailabilityCountdownActive && !!strings.productAvailabilityLabel && (
        <Chip label={strings.productAvailabilityLabel} color="yellow" />
      )}
      {inStock &&
        !isPreorderActive &&
        !isAvailabilityCountdownActive &&
        !!productDiscountText && (
          <Chip label={productDiscountText} color="black-yellow" />
        )}
      {inStock &&
        lowStock &&
        !isPreorderActive &&
        !isAvailabilityCountdownActive && (
          <Chip label={strings.productLowStock} color="black" />
        )}
      {!inStock && !isPreorderActive && !isAvailabilityCountdownActive && (
        <Chip label={strings.productOutOfStock} color="gray" />
      )}
      {gender === 'women' && !!strings.productWomensLabel && (
        <Chip label={strings.productWomensLabel} color="black" />
      )}
    </>
  )
}

export default ProductHeroChips
